import controller from './chart-contact-agg.controller';
import { bindings } from '../chart-abstract-base';
import template from './template.html';

export default {
    bindings: {
        ...bindings,
        onChartSelection: '&',
        onChartPan: '&',
        extremes: '<',
    },
    template,
    controller
};
